import Platform from "./apps/sales-platform";
import { useContext } from "react";
import { AuthenticatedUserContext } from "./apps/context/AuthenticatedUserContext";

export function App() {
  const { user } = useContext(AuthenticatedUserContext);
  return <Platform userLogged={user} />;
}
